export const setWebStorage = (key: string, val: string) => {
  sessionStorage.setItem(key, val);
};
export const getWebStorage = (key: string) => {
  return sessionStorage.getItem(key);
};
